import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import { annotationsTableChange } from '../../actions'

function mapStateToProps(state, hocProps) {
    const module = _.get(hocProps, 'module', null)
    const id = _.get(hocProps, 'id', null)
    const block = _.get(hocProps, 'block', null)

    return {
        rows: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', 'table', 'rows']),
        pagination: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', 'table', 'pagination']),
        sorted: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', 'table', 'sorted']),
        isLoading: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', 'table', 'isLoading']),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            annotationsTableChange,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
